import { InputGroup, Intent, TextArea } from "@blueprintjs/core";
import { IInputProps } from "../types";
import { IText } from "components/Template/types";
import { doDisabled, doHidden, doInvalid } from "components/Template/utils";
import Validate from "components/Template/Validate";
import Override from "components/Template/Override";
import ChangeHighlight from "components/Template/ChangeHighlight";
import "./Text.scss";

export interface ITextProps extends IInputProps {
  template: IText;
}

const Text = (props: ITextProps) => {
  const { template, mutators, metadata } = props;
  const { getValue, handleChange } = mutators;

  if (doHidden(props)) {
    if (!metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput.push(template.name);
    }
    return null;
  } else {
    if (metadata.hiddenInput.includes(template.name)) {
      metadata.hiddenInput = metadata.hiddenInput.filter((i) => i === template.name);
    }
  }
  const disabled = doDisabled(props);
  const invalid = doInvalid(props);

  const renderInput = () => {
    const currentValue = (getValue(template.name) ?? "") as string;
    const storedValue = mutators.getStoredValue ? (mutators.getStoredValue(template.name) ?? "") : undefined;
    const hasChanged = storedValue !== undefined && storedValue !== currentValue;

    const handleUndo = () => {
      if (mutators.setStoredValue) {
        handleChange && handleChange(template.name, storedValue as string);
      }
    };

    const handleKeep = () => {
      if (mutators.setStoredValue) {
        mutators.setStoredValue(template.name, currentValue);
      }
    };

    switch (template.variant) {
      case "area":
        return (
          <ChangeHighlight
            changed={hasChanged}
            onUndo={hasChanged ? handleUndo : undefined}
            onKeep={hasChanged ? handleKeep : undefined}
            changePath={mutators.getPath(template.name)}
          >
            <TextArea
              key={template.name}
              id={template.name}
              intent={invalid ? Intent.DANGER : Intent.NONE}
              value={currentValue}
              {...(handleChange ? { onChange: (e) => handleChange(template.name, e.target.value) } : { readOnly: true })}
              disabled={disabled}
              growVertically
              fill
            />
          </ChangeHighlight>
        );
      case "text":
      default:
        return (
          <ChangeHighlight
            changed={hasChanged}
            onUndo={hasChanged ? handleUndo : undefined}
            onKeep={hasChanged ? handleKeep : undefined}
            changePath={mutators.getPath(template.name)}
          >
            <InputGroup
              key={template.name}
              id={template.name}
              intent={invalid ? Intent.DANGER : Intent.NONE}
              value={currentValue}
              {...(handleChange ? { onChange: (e) => handleChange(template.name, e.target.value) } : { readOnly: true })}
              disabled={disabled}
            />
          </ChangeHighlight>
        );
    }
  };
  return (
    <Validate {...props} className="text" showLabel showInfo>
      {renderInput()}
      <Override {...props} />
    </Validate>
  );
};

export default Text;
